import type { TabModel } from '../state/commandCenterStore';

interface SectionTabsProps {
  tabs: TabModel[];
  active: string;
  onSelect: (slug: string) => void;
}

/** Section filter strip; the dot turns unhealthy when a section holds a warn or crit card. */
const SectionTabs = ({ tabs, active, onSelect }: SectionTabsProps) => (
  <div className="agent-tabs" id="agentTabs">
    {tabs.map((tab) => (
      <button
        key={tab.slug}
        type="button"
        className="atab"
        data-active={String(tab.slug === active)}
        onClick={() => onSelect(tab.slug)}
      >
        {tab.health === 'none' ? null : <i className={`hdot ${tab.health}`} />}
        {tab.title}
      </button>
    ))}
  </div>
);

export default SectionTabs;
